import { Col, DesignTokens, Row, Title } from "melco-ui";
import {
  ReportingMelcoMachineStatisticsModelsView,
  ReportingMelcoMachineStatisticsModelsViewGroups,
} from "melco-shared-logic";
import {
  backgroundColorLookup,
  DisplayWrapper,
  EmptyMachineGroupWrapper,
  machineStatusDisplayLookup,
  NA,
} from "../../../helper/reporting/status";
import { MachineStatusGrid } from "../../status/grid/MachineStatusGrid";
import { isEmpty } from "lodash-es";
import { MachineStatusGridItem } from "../../status/grid/MachineStatusGridItem";
import { EditGroupButton } from "./EditGroupButton";
import { useTranslation } from "react-i18next";
import { getTimeDifference } from "../../../helper/reporting/reportingHelpers";

type DisplayMachineStatusViewGroupedProps = {
  viewDetail: ReportingMelcoMachineStatisticsModelsView;
  activeTooltip: string | null;
  onToggleTooltip: (machineName: string) => void;
};

const { colors, spacings } = DesignTokens;

export const DisplayMachineStatusViewGrouped: React.FC<
  DisplayMachineStatusViewGroupedProps
> = ({ viewDetail, activeTooltip, onToggleTooltip }) => {
  const { t } = useTranslation();

  return (
    <>
      <>
        {viewDetail?.group_list && viewDetail?.group_list?.length > 0 && (
          <>
            {viewDetail?.group_list?.map(
              (group: ReportingMelcoMachineStatisticsModelsViewGroups) => {
                return (
                  <>
                    <DisplayWrapper>
                      {group?.machine_list &&
                      group?.machine_list?.length > 0 ? (
                        <MachineStatusGrid title={group?.name ?? ""}>
                          <>
                            {group?.machine_list?.map((machine: any) => {
                              let machineStateValues = machine?.last_status
                                .split(",")
                                .map((value: any) => value.trim()) // Trim spaces
                                .join("-"); // Join with hyphen
                              // Create a lookup key by combining `a` and the trimmed and joined `b`
                              let lookupKey = "";
                              lookupKey = machine?.event_type ?? "";
                              // console.log(JSON.stringify(machine));
                              if (lookupKey == "MACHINE_STOP") {
                                if (machine?.stop_type == "ESTOP")
                                  machineStateValues = machine?.stop_type;
                              }
                              if (!isEmpty(machineStateValues))
                                lookupKey =
                                  lookupKey + "-" + machineStateValues;
                              // Find the matching result for the lookup key
                              const result =
                                machineStatusDisplayLookup[lookupKey];

                              const backgroundColor =
                                backgroundColorLookup[
                                  result?.bgColorId ? result.bgColorId : ""
                                ];

                              console.log(
                                machine?.device_id ? machine?.device_id : "",
                                "   ",
                                machine?.name ? machine?.name : "",
                                " ",
                                machine?.event_type ? machine?.event_type : "",
                                " ",
                                result?.textId
                                  ? t(
                                      `reporting.machinestatus.status.${result?.textId}`,
                                      {
                                        defaultValue: "Unknown",
                                      }
                                    )
                                  : "NA",
                                "       ",
                                result?.bgColorId
                                  ? result?.bgColorId + "-color ---> "
                                  : "      ",

                                backgroundColor,

                                " "
                              );
                              return (
                                <>
                                  <MachineStatusGridItem
                                    key={
                                      viewDetail.id +
                                      "" +
                                      group.name +
                                      "" +
                                      machine.device_id
                                    }
                                    keyForTooltip={
                                      viewDetail.id +
                                      "" +
                                      group.name +
                                      "" +
                                      machine.device_id
                                    }
                                    machineName={machine.name}
                                    status={result ?? NA}
                                    isActive={
                                      activeTooltip ===
                                      viewDetail.id +
                                        "" +
                                        group.name +
                                        "" +
                                        machine.device_id
                                    }
                                    onToggle={onToggleTooltip}
                                    tooltip={
                                      machine?.inactive
                                        ? getTimeDifference(
                                            machine?.last_sync_date
                                          ) +
                                          " " +
                                          t(
                                            "reporting.machinestatus.status.ago"
                                          )
                                        : undefined
                                    }
                                  />
                                </>
                              );
                            })}
                          </>
                        </MachineStatusGrid>
                      ) : (
                        <>
                          <Title level={5}>{group?.name}</Title>
                          <EmptyMachineGroupWrapper>
                            <Row gutter={[spacings.middle, spacings.middle]}>
                              <Col xs={24} md={24} xl={24}>
                                <div style={{ textAlign: "center" }}>
                                  {t(
                                    "reporting.machinestatus.no_machine_added"
                                  )}
                                </div>
                              </Col>
                              <Col xs={24} md={24} xl={24}>
                                <div style={{ textAlign: "center" }}>
                                  <EditGroupButton groupId={group?.id ?? ""} />
                                </div>
                              </Col>
                            </Row>
                          </EmptyMachineGroupWrapper>
                        </>
                      )}
                    </DisplayWrapper>
                  </>
                );
              }
            )}
          </>
        )}
      </>
    </>
  );
};
